module.exports = __webpack_public_path__ + "img/updating.1f237ff6.png";